import React, { Component } from 'react'
import { find } from 'lodash'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import menuRouteUtil from '../utils/menuRoute.util'
import MenuItems from './MenuItems'
import SubMenu from './SubMenu'

interface MenuProps extends RouteComponentProps {
  fold: boolean
  permittedModules: string[]
  onRoute: () => void
}

class Menu extends Component<MenuProps> {
  get activeGroup () {
    return menuRouteUtil.groupFromPath(this.props.location.pathname)
  }

  get subMenu () {
    return this.activeGroup &&
      <SubMenu
        type={this.activeGroup.name}
        permittedModules={this.props.permittedModules}
        onRoute={this.props.onRoute} />
  }

  /**
   * Redirect not permitted routes
   *
   * This is to redirect the not permitted default routes
   * to it's next posible route in cascading fallback mechanism.
   *
   * @param to The current routed menu route's 'to' location
   */
  redirectNotPermittedRoutes (to?: string) {
    setTimeout(() => {
      if (this.activeGroup && to) {
        const permittedRoutes = menuRouteUtil.collectPermittedCombinedSubsidiaries(
          this.activeGroup.name,
          this.props.permittedModules
        )
        const isPermitted = find(permittedRoutes, route => route.to === to)
        if (!isPermitted && permittedRoutes) {
          const firstRoute = permittedRoutes[0]
          this.props.history.push(firstRoute.to)
        }
      }
    }, 100)
  }

  handleRoute = (to?: string) => {
    this.props.onRoute()
    this.redirectNotPermittedRoutes(to)
  }

  render () {
    return (
      <div>
        <MenuItems
          fold={this.props.fold}
          permittedModules={this.props.permittedModules}
          onRoute={this.handleRoute} />
        {this.subMenu}
      </div>
    )
  }
}

export default withRouter(Menu)
